import React from 'react';
import { Loader2 } from 'lucide-react';

export default function DriveUploadJobList({ c, jobs }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', maxHeight: '200px', overflow: 'auto' }}>
      <style>{'@keyframes driveUploadSpin { to { transform: rotate(360deg); } }'}</style>
      {jobs.map((job) => {
        const done = job.status === 'completed' || job.status === 'failed' || job.status === 'cancelled';
        const statusColor = job.status === 'completed' ? c.ok : job.status === 'failed' ? c.err : job.status === 'running' ? c.accent : c.muted;
        const pct = job.totalBytes ? Math.round(((job.bytesDone || 0) / job.totalBytes) * 100) : 0;
        return (
          <div
            key={job.id}
            style={{
              display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 8px',
              borderRadius: '6px', background: done ? 'transparent' : c.subtleBg,
              opacity: job.status === 'completed' ? 0.6 : 1,
            }}
          >
            {job.status === 'running' ? <Loader2 size={13} color={statusColor} style={{ animation: 'driveUploadSpin 1s linear infinite' }} /> : null}
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: '11px', fontWeight: 500, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {job.relativePath}
              </div>
              {job.status === 'running' && (
                <div style={{ fontSize: '10px', color: c.muted }}>{pct}%</div>
              )}
              {job.status === 'failed' && job.error && (
                <div style={{ fontSize: '10px', color: c.err, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{job.error}</div>
              )}
            </div>
            <span style={{ fontSize: '10px', color: statusColor, fontWeight: 600, letterSpacing: '0.02em' }}>{job.status}</span>
          </div>
        );
      })}
    </div>
  );
}
